<template>
  <div class="MessageDetails">
    <el-dialog
      :title="value.title"
      :visible.sync="dialogVisible"
      width="450px"
      :show-close="false"
    >
      <span>{{ value.content }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  //  消息详情
  name: 'MessageDetails',
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: true
    }
  },
  computed: {},
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.$emit('hide')
      }
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.box{}
.el-dialog__body>span:nth-child(1){
  white-space: pre-wrap;
}
</style>
